import React from 'react';
import { ApplyButton, ClearButton, FilterFooter } from '../../base-elements/filters/FilterFooter';
import { CommonCalendarState } from '../types';
import { CalendarDispatchAction } from './hooks';

export type CalendarFooterProps = {
  footerClearButtonComponent?: any;
  footerDoneButtonComponent?: any;
  footerCheckboxComponent?: any;
  footerContainerComponent?: any;
  footerSelectComponent?: any;
  style?: any;
  dispatch: CalendarDispatchAction;
  state: CommonCalendarState;
  footerSettings?: {
    elementsToShow: Array<string>;
    labelKeyInformation?: string;
  };
  footerInformationTextComponent?: Record<string, object>;
  onSaveFunction?: (value: boolean) => void;
  isMobile?: boolean;
  callToAction?: any;
  format?: string;
  firstAvailableDay?: number;
};

const CalendarFooter = (props: CalendarFooterProps) => {
  const {
    footerClearButtonComponent = {},
    footerDoneButtonComponent = {},
    dispatch,
    state
  } = props;

  const isClearDisabled = state.selectedRange.size === 0;
  const isDoneDisabled = state.selectedRange.size === 0 && state.currentDate.size === 0;

  return (
    <FilterFooter
      actionsSlot={
        <>
          <ClearButton
            onPress={() => {
              dispatch({ type: 'CLEAR_ACTION' });
            }}
            {...footerClearButtonComponent}
            isDisabled={isClearDisabled}
          />
          <ApplyButton
            {...footerDoneButtonComponent}
            onPress={() => {
              if (state.valid) {
                dispatch({ type: 'CHANGE_DATES', payload: state.selectedRange });
                dispatch({ type: 'CLOSE_POPOVER_ACTION' });
                props.onSaveFunction?.(true);
              }
            }}
            isDisabled={isDoneDisabled}
          />
        </>
      }
    />
  );
};

export default CalendarFooter;
